import React, { PureComponent, useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import Slider from 'react-slick';
import { Player } from 'ThreeTerminal_pc/video';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import styles from './index.css';
import { getCoverList } from '../../services/api';

const pickContent = (props, name) => {
    const { content } = props;
    let result = [];

    content.modules.forEach(item => {
        if (name === item.title) result = item.data.articleList;
    });

    result.forEach(item => {
        item.thumbnail = item.thumbnail || (item.thumbnails?.image && item.thumbnails?.image[0]?.url);
    });

    return result;
};

const isShowPickContent = (props, name) => {
    const { content } = props;
    let result = 1;

    content.modules.forEach(item => {
        if (name === item.title) result = item.display;
    });

    return result;
};

const VideoPlayer = errorBoundary(props => {
    const [videoPlay, setVideoPlay] = useState(true);
    const [menu, setMenu] = useState(0);
    const [activeVideo, setActiveVideo] = useState(0);
    const videos = pickContent(props, '视频模块');

    return (
        <div className={styles.videoPlay}>
            {videoPlay ? (
                <Player
                    videoConfig={{
                        videoLargePoster: videos[activeVideo].thumbnail,
                        videoPlayUrl: videos[activeVideo].videoPlayUrl,
                        title: videos[activeVideo].title,
                    }}
                    playermsg={{
                        width: 720,
                        height: 424,
                        isAuth: 'auth',
                        autoPlay: false,
                    }}
                />
            ) : null}
            <div className={styles.side_menu}>
                <div
                    className={styles.header}
                    onClick={() => {
                        setMenu(menu ? 0 : 1);
                        setActiveVideo(0);
                    }}>
                    <div className={`${menu === 0 ? styles.active : null}`}>精彩片段</div>
                    {/* <div className={`${menu === 1 ? styles.active : null}`}>往期回顾</div> */}
                </div>
                <div className={styles.items}>
                    {videos.map((item, index) => {
                        return (
                            <div
                                key={index}
                                onClick={() => {
                                    setActiveVideo(index);
                                    setVideoPlay(false);
                                    setTimeout(() => setVideoPlay(true));
                                }}
                                className={`${styles.item} ${activeVideo === index ? styles.item_active : null}`}>
                                {item.title}
                            </div>
                        );
                    })}
                </div>
            </div>
            <div className={styles.qrcode}>
                <img src={require('./assets/qr1.png')} alt="" />
                <img src={require('./assets/qr2.png')} alt="" />
                <img src={require('./assets/qr3.png')} alt="" />
            </div>
        </div>
    );
});

const Brilliant = errorBoundary(props => {
    const slide = useRef(null);
    const slideSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
    };
    const videos = pickContent(props, '精彩片段模块');
    const isShow = isShowPickContent(props, '精彩片段模块');

    const formateData = [];

    videos.slice(1, videos.length).forEach((item, index) => {
        const key = parseInt(index / 4);

        formateData[key] = formateData[key] || [];
        formateData[key].push(item);
    });

    return isShow ? (
        <div className={styles.brilliant}>
            <img className={styles.title_img} src={require('./assets/blilliant.png')} />
            <div className={styles.content}>
                <div
                    className={styles.left}
                    onClick={() => {
                        window.open(videos[0].url, '_blank');
                    }}>
                    <img src={videos[0].thumbnail} alt="" />
                    <div>{videos[0].title}</div>
                </div>
                <div className={styles.right}>
                    <div
                        className={styles.slide_left_btn}
                        onClick={() => {
                            slide.current.slickPrev();
                        }}>
                        <img src={require('./assets/arrow.png')} alt="" />
                    </div>
                    <div className={styles.slide_right_btn} onClick={() => slide.current.slickNext()}>
                        <img src={require('./assets/arrow.png')} alt="" />
                    </div>
                    <Slider {...slideSettings} ref={slider => (slide.current = slider)}>
                        {formateData.map((item, _index) => {
                            return (
                                <div key={_index} className={styles.slide_item}>
                                    {item.map((card, index) => {
                                        return (
                                            <div
                                                key={index}
                                                onClick={() => {
                                                    window.open(card.url, '_blank');
                                                }}
                                                className={styles.card}>
                                                <img src={card.thumbnail} alt="" />
                                                <div>{card.title}</div>
                                            </div>
                                        );
                                    })}
                                </div>
                            );
                        })}
                    </Slider>
                </div>
            </div>
        </div>
    ) : (
        ''
    );
});

const Article = errorBoundary(props => {
    const [fold, setFold] = useState(true);
    const article = pickContent(props, '相关文章模块');
    const isShow = isShowPickContent(props, '相关文章模块');

    return isShow ? (
        <div className={styles.article}>
            <img className={styles.title_img} src={require('./assets/article.png')} />
            <div className={styles.content}>
                {article.slice(0, fold ? 2 : 7).map((item, index) => {
                    return (
                        <div
                            key={index}
                            onClick={() => {
                                window.open(item.url, '_blank');
                            }}
                            className={styles.item}>
                            <img src={item.thumbnail} alt="" />
                            <div>
                                <div>{item.title}</div>
                                <div>{item.source}</div>
                            </div>
                        </div>
                    );
                })}
            </div>
            {fold ? (
                <div className={styles.unfold} onClick={() => setFold(false)}>
                    <img src={require('./assets/arrow_red.png')} alt="" />
                </div>
            ) : null}
        </div>
    ) : (
        ''
    );
});

const Pics = errorBoundary(props => {
    const slide = useRef(null);
    const data = pickContent(props, '嘉宾图集模块');
    const isShow = isShowPickContent(props, '嘉宾图集模块');
    const [activePic, setActivePic] = useState(0);
    const slideSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        autoplaySpeed: 3000,
        autoplay: true,
        slidesToShow: data.length > 3 ? 3 : data.length,
        slidesToScroll: 1,
        vertical: true,
        verticalSwiping: true,
        arrows: false,
        afterChange: index => setActivePic(index),
    };

    return isShow ? (
        <div className={styles.pics}>
            <img className={styles.title_img} src={require('./assets/pics.png')} />
            <div className={styles.content}>
                <div className={styles.left}>
                    <img src={data[activePic].thumbnail} alt="" />
                    <div className={styles.title}>{data[activePic].source}</div>
                </div>
                <div className={styles.right}>
                    <div
                        className={styles.slide_left_btn}
                        onClick={() => {
                            slide.current.slickPrev();
                            setActivePic((activePic + 1) % data.length);
                        }}>
                        <img src={require('./assets/arrow.png')} alt="" />
                    </div>
                    <div
                        className={styles.slide_right_btn}
                        onClick={() => {
                            slide.current.slickNext();
                            setActivePic((activePic - 1 < 0 ? data.length - 1 : activePic - 1) % data.length);
                        }}>
                        <img src={require('./assets/arrow.png')} alt="" />
                    </div>
                    <Slider {...slideSettings} ref={slider => (slide.current = slider)}>
                        {data.map((item, index) => {
                            return (
                                <div key={index} className={styles.slideImg} onClick={() => setActivePic(index)}>
                                    <img src={item.thumbnail} alt="" />
                                </div>
                            );
                        })}
                    </Slider>
                </div>
            </div>
        </div>
    ) : (
        ''
    );
});

const Review = errorBoundary(props => {
    const [reviewData, setReviewData] = useState([]);

    const getRevewData = async () => {
        let result = await getCoverList();

        result = result.filter(item => !location.href.includes(item.base62Id));

        setReviewData(result);
    };

    useEffect(() => {
        getRevewData();
    }, []);

    const isShow = isShowPickContent(props, '往期回顾模块');

    return isShow ? (
        <div className={styles.review}>
            <img className={styles.title_img} src={require('./assets/review.png')} />
            <div className={styles.reviewBox}>
                {reviewData.map((item, index) => {
                    return (
                        <div
                            onClick={() => {
                                window.open(item.url, '_blank');
                            }}
                            key={index}
                            className={styles.item}>
                            <div style={{ backgroundImage: `url(${item.thumbnail})` }} alt="" />
                        </div>
                    );
                })}
            </div>
        </div>
    ) : (
        ''
    );
});

class Layout extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    componentDidMount() {
        const { content } = this.props;

        if (content.title) {
            document.title = content.title;
        }
    }

    render() {
        const { content } = this.props;
        const banner = pickContent(this.props, '开屏封面');
        const thx = pickContent(this.props, '特别鸣谢模块');
        const info = pickContent(this.props, '页面尾栏');
        const comment = pickContent(this.props, '热门评论模块');
        const infoImageUrl =
            (info && info[5] && info[5].thumbnail) || 'https://x2.ifengimg.com/fe/shank/custom/cover.d8084604.png';
        const isShowComment = isShowPickContent(this.props, '热门评论模块');
        const isShowPageBottom = isShowPickContent(this.props, '页面尾栏');

        console.log(banner);

        return (
            <div>
                <div className={styles.container}>
                    <div className={styles.cover}>
                        <img src={banner[0].thumbnail} alt="" />
                    </div>
                    <VideoPlayer content={content} />
                    <Brilliant content={content} />
                    <Article content={content} />
                    <Pics content={content} />
                    <Review content={content} />
                    {isShowComment ? (
                        <div className={styles.bottom}>
                            <img src={require('./assets/comment.png')} alt="" />
                            <div>
                                <iframe
                                    src={`http://widget.weibo.com/topics/topic_vote_base.php?uid=1988800805&border=0&footbar=1&width=821&height=369&refer=1&filter=1&language=zh_cn&version=base&dup=1&antispam=1&isOutTopicSearch=2&isshowright=1&tag=${encodeURIComponent(
                                        encodeURIComponent(comment[0].source),
                                    )}&app_src=C0s9q&r=1577349024256`}
                                    width="821"
                                    height="960"
                                    frameBorder="0"
                                    scrolling="no"
                                    marginHeight="0"
                                    loading="lazy"
                                />
                            </div>
                        </div>
                    ) : (
                        ''
                    )}
                    <div className={styles.thx}>
                        <img src={require('./assets/thx.png')} alt="" />
                        <div>
                            {thx.map((item, index) => (
                                <div key={index} className={styles.thx_card}>
                                    <img src={item.thumbnail} alt="" />
                                </div>
                            ))}
                            <div
                                className={styles.backtotop}
                                onClick={() => {
                                    window.scroll(0, 0);
                                }}>
                                <img src={require('./assets/back_top.png')} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
                {isShowPageBottom ? (
                    <div className={styles.tel}>
                        <div>
                            <div>联系我们</div>
                            <div>
                                {info?.[4]?.source && <>{info[4]?.title || '出品'}：{info[4].source}</>}{' '}
                                {info?.[3]?.source && <span>{info[3]?.title || '执行制片人'}：{info[3].source}</span>}{' '}
                                {info?.[2]?.source && <span>{info[2]?.title || '主持人'}：{info[2].source}</span>}
                            </div>
                            <div>
                                {info?.[1]?.source && <>{info[1]?.title || '邮箱'}：{info[1].source}</>}{' '}
                                <span>地址：北京市朝阳区望京启阳路4号中轻大厦</span>
                            </div>
                        </div>
                        <img src={infoImageUrl} alt="" />
                    </div>
                ) : (
                    ''
                )}
            </div>
        );
    }
}

export default errorBoundary(Layout);
